(function () {
  "use strict";

  var root = document.getElementById("mf-nasu");
  if (!root) return;

  var el = {
    launcher: document.getElementById("mf-nasu-launcher"),
    visibilityToggle: document.getElementById("mf-nasu-visibility-toggle"),
    visibilityLabel: document.getElementById("mf-nasu-visibility-label"),
    panel: document.getElementById("mf-nasu-panel"),
    close: document.getElementById("mf-nasu-close"),
    settingsToggle: document.getElementById("mf-nasu-settings-toggle"),
    settings: document.getElementById("mf-nasu-settings"),
    mute: document.getElementById("mf-nasu-mute"),
    proactive: document.getElementById("mf-nasu-proactive"),
    reducedMotion: document.getElementById("mf-nasu-reduced-motion"),
    clear: document.getElementById("mf-nasu-clear"),
    messages: document.getElementById("mf-nasu-messages"),
    prompts: document.getElementById("mf-nasu-prompts"),
    status: document.getElementById("mf-nasu-status"),
    form: document.getElementById("mf-nasu-form"),
    input: document.getElementById("mf-nasu-input"),
    send: document.getElementById("mf-nasu-send"),
    stateLabel: document.getElementById("mf-nasu-state-label"),
    characters: Array.prototype.slice.call(root.querySelectorAll("[data-nasu-character]"))
  };

  var state = {
    bridge: null,
    user: null,
    threadId: null,
    busy: false,
    open: false,
    currentState: "idle",
    frameTimer: null,
    idleEventTimer: null,
    frameIndex: 0,
    inactivityTimer: null,
    preferences: {
      launcher_corner: "bottom_left",
      animation_sounds_muted: true,
      proactive_suggestions_enabled: false,
      reduced_motion: false,
      assistant_enabled: true,
      launcher_x: null,
      launcher_y: null
    }
  };

  el.launcher.addEventListener("click", function (event) {
    if (el.launcher.dataset.wasDragged === "yes") {
      el.launcher.dataset.wasDragged = "no";
      return;
    }
    openPanel();
  });
  el.close.addEventListener("click", closePanel);
  if (el.visibilityToggle) el.visibilityToggle.addEventListener("click", toggleVisibility);
  el.settingsToggle.addEventListener("click", toggleSettings);
  el.form.addEventListener("submit", function (event) {
    event.preventDefault();
    sendMessage(el.input.value);
  });
  el.input.addEventListener("input", function () {
    if (!state.busy) setCharacterState(el.input.value.trim() ? "listening" : "idle");
    resetInactivity();
  });
  el.input.addEventListener("keydown", function (event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      el.form.requestSubmit();
    }
  });
  el.prompts.addEventListener("click", function (event) {
    if (event.target.tagName === "BUTTON") sendMessage(event.target.textContent || "");
  });
  el.clear.addEventListener("click", clearConversation);
  [el.mute, el.proactive, el.reducedMotion].forEach(function (input) {
    input.addEventListener("change", savePreferences);
  });
  document.addEventListener("keydown", function (event) {
    if (!state.open) return;
    if (event.key === "Escape") closePanel();
    if (event.key === "Tab") trapFocus(event);
  });
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) stopAnimation();
    else renderCharacter(state.currentState);
  });
  window.addEventListener("memoryfuel:study-lounge-ready", connectBridge);
  window.addEventListener("memoryfuel:auth-state", function (event) {
    setUser(event.detail ? event.detail.user : null);
  });
  window.addEventListener("memoryfuel:nasu-state", function (event) {
    var detail = event.detail || {};
    if (detail.source !== "flashcards" || state.busy) return;
    setCharacterState(detail.state || "idle");
  });
  window.addEventListener("resize", function () {
    if (!state.user) return;
    applySavedPosition();
    constrainPanelToViewport();
  });
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", constrainPanelToViewport);
    window.visualViewport.addEventListener("scroll", constrainPanelToViewport);
  }
  if (window.ResizeObserver) {
    new ResizeObserver(function () { constrainPanelToViewport(); }).observe(el.panel);
  }
  setupLauncherDrag();
  connectBridge();

  function connectBridge() {
    state.bridge = window.MemoryFuelStudyLounge || null;
    if (!state.bridge) return;
    setUser(state.bridge.getCurrentUser());
  }

  async function setUser(user) {
    state.user = user || null;
    if (!state.user) {
      state.threadId = null;
      closePanel();
      root.hidden = true;
      if (el.visibilityToggle) el.visibilityToggle.hidden = true;
      return;
    }
    if (el.visibilityToggle) el.visibilityToggle.hidden = false;
    await loadPreferences();
    if (state.preferences.assistant_enabled) await loadHistory();
    applyVisibility();
    if (state.preferences.assistant_enabled) window.requestAnimationFrame(applySavedPosition);
    setCharacterState("idle");
    resetInactivity();
  }

  function openPanel() {
    if (!state.user || state.open) return;
    state.open = true;
    el.panel.hidden = false;
    el.launcher.setAttribute("aria-expanded", "true");
    setCharacterState("idle");
    window.requestAnimationFrame(constrainPanelToViewport);
    window.setTimeout(function () { el.input.focus(); }, 0);
    resetInactivity();
  }

  function closePanel() {
    if (!state.open) return;
    state.open = false;
    el.panel.hidden = true;
    el.launcher.setAttribute("aria-expanded", "false");
    el.launcher.focus();
    setCharacterState("idle");
  }

  function toggleSettings() {
    var showing = el.settings.hidden;
    el.settings.hidden = !showing;
    el.settingsToggle.setAttribute("aria-expanded", showing ? "true" : "false");
  }

  async function toggleVisibility() {
    if (!state.user) return;
    state.preferences.assistant_enabled = !state.preferences.assistant_enabled;
    if (!state.preferences.assistant_enabled && state.open) {
      state.open = false;
      el.panel.hidden = true;
      el.launcher.setAttribute("aria-expanded", "false");
    }
    applyVisibility();
    if (state.preferences.assistant_enabled) window.requestAnimationFrame(applySavedPosition);
    await savePreferences();
  }

  function applyVisibility() {
    var enabled = Boolean(state.user && state.preferences.assistant_enabled);
    root.hidden = !enabled;
    if (!el.visibilityToggle) return;
    el.visibilityToggle.hidden = !state.user;
    el.visibilityToggle.classList.toggle("is-off", !state.preferences.assistant_enabled);
    el.visibilityToggle.setAttribute("aria-pressed", state.preferences.assistant_enabled ? "true" : "false");
    el.visibilityToggle.setAttribute("aria-label", state.preferences.assistant_enabled ? "Hide Nasú study assistant" : "Show Nasú study assistant");
    if (el.visibilityLabel) el.visibilityLabel.textContent = state.preferences.assistant_enabled ? "Visible" : "Hidden";
  }

  async function loadPreferences() {
    if (!state.bridge || !state.user) return;
    var result = await state.bridge.db.from("nasu_preferences").select(
      "launcher_corner,launcher_x,launcher_y,assistant_enabled,animation_sounds_muted,proactive_suggestions_enabled,reduced_motion"
    ).eq("user_id", state.user.id).maybeSingle();
    if (!result.error && result.data) state.preferences = Object.assign(state.preferences, result.data);
    syncPreferences();
  }

  function syncPreferences() {
    el.mute.checked = Boolean(state.preferences.animation_sounds_muted);
    el.proactive.checked = Boolean(state.preferences.proactive_suggestions_enabled);
    el.reducedMotion.checked = Boolean(state.preferences.reduced_motion);
    root.setAttribute("data-corner", state.preferences.launcher_corner || "bottom_left");
    applyVisibility();
    if (state.preferences.assistant_enabled) window.requestAnimationFrame(applySavedPosition);
    renderCharacter(state.currentState);
  }

  async function savePreferences() {
    if (!state.bridge || !state.user) return;
    state.preferences.animation_sounds_muted = el.mute.checked;
    state.preferences.proactive_suggestions_enabled = el.proactive.checked;
    state.preferences.reduced_motion = el.reducedMotion.checked;
    var result = await state.bridge.db.from("nasu_preferences").upsert({
      user_id: state.user.id,
      launcher_corner: state.preferences.launcher_corner,
      launcher_x: state.preferences.launcher_x,
      launcher_y: state.preferences.launcher_y,
      assistant_enabled: state.preferences.assistant_enabled,
      animation_sounds_muted: state.preferences.animation_sounds_muted,
      proactive_suggestions_enabled: state.preferences.proactive_suggestions_enabled,
      reduced_motion: state.preferences.reduced_motion
    });
    el.status.textContent = result.error ? "Those settings could not be saved." : "Settings saved.";
    renderCharacter(state.currentState);
  }

  async function loadHistory() {
    if (!state.bridge || !state.user) return;
    var threadResult = await state.bridge.db.from("nasu_threads").select("id")
      .eq("user_id", state.user.id).eq("status", "active").order("updated_at", { ascending: false }).limit(1).maybeSingle();
    if (threadResult.error || !threadResult.data) return;
    state.threadId = threadResult.data.id;
    var results = await Promise.all([
      state.bridge.db.from("nasu_messages").select("id,role,content,created_at")
        .eq("thread_id", state.threadId).order("created_at", { ascending: true }).limit(100),
      state.bridge.db.from("nasu_proposals").select("id,action_type,payload,display_summary,explanation,source,conflicts,status,expires_at,result")
        .eq("thread_id", state.threadId).in("status", ["pending", "executed"]).order("created_at", { ascending: true }).limit(30)
    ]);
    if (!results[0].error && results[0].data && results[0].data.length) {
      el.messages.textContent = "";
      results[0].data.forEach(function (message) {
        if (message.role !== "tool") appendMessage(message.role, message.content);
      });
      (results[1].data || []).forEach(renderProposal);
      scrollMessages();
    }
  }

  async function sendMessage(value) {
    var message = String(value || "").trim();
    if (!message || state.busy || !state.bridge || !state.user) return;
    state.busy = true;
    el.send.disabled = true;
    el.input.value = "";
    el.status.textContent = "Nasú is gathering the useful pieces…";
    appendMessage("user", message);
    var assistant = appendMessage("assistant", "");
    setCharacterState("thinking");

    try {
      var sessionResult = await state.bridge.db.auth.getSession();
      var session = sessionResult.data.session;
      if (!session) throw new Error("login");
      var requestId = createUuid();
      var endpoint = state.bridge.db.supabaseUrl.replace(/\/$/, "") + "/functions/v1/nasu-chat";
      var response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Authorization": "Bearer " + session.access_token,
          "apikey": state.bridge.db.supabaseKey,
          "Content-Type": "application/json",
          "Idempotency-Key": requestId
        },
        body: JSON.stringify({
          message: message, thread_id: state.threadId, request_id: requestId,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"
        })
      });
      if (!response.ok || !response.body) {
        var problem = await response.json().catch(function () { return {}; });
        throw new Error(problem.error || "request_failed");
      }
      await consumeEvents(response.body, function (event, data) {
        if (event === "state") {
          setCharacterState(data.state || "thinking");
          el.status.textContent = data.detail || stateText(data.state);
        } else if (event === "delta") {
          assistant._rawContent = (assistant._rawContent || "") + (data.text || "");
          assistant.querySelector("p").textContent = cleanChatText(assistant._rawContent);
          setCharacterState("talking");
          scrollMessages();
        } else if (event === "proposal") {
          renderProposal(data);
        } else if (event === "done") {
          state.threadId = data.thread_id || state.threadId;
          el.status.textContent = "Ready when you are.";
        } else if (event === "error") {
          throw new Error(data.error || "stream_failed");
        }
      });
      if (!assistant.querySelector("p").textContent.trim()) assistant.remove();
      setCharacterState("idle");
    } catch (error) {
      if (!assistant.querySelector("p").textContent.trim()) assistant.querySelector("p").textContent = safeError(error);
      el.status.textContent = "Nothing was changed. You can try again.";
      setCharacterState("error");
      window.setTimeout(function () { if (!state.busy) setCharacterState("idle"); }, 3200);
    } finally {
      state.busy = false;
      el.send.disabled = false;
      resetInactivity();
      scrollMessages();
    }
  }

  function appendMessage(role, content) {
    var item = document.createElement("div");
    var text = document.createElement("p");
    item.className = "mf-nasu-message " + (role === "user" ? "is-user" : "is-assistant");
    item._rawContent = String(content || "");
    text.textContent = role === "user" ? item._rawContent : cleanChatText(item._rawContent);
    item.appendChild(text);
    el.messages.appendChild(item);
    scrollMessages();
    return item;
  }

  function cleanChatText(value) {
    return String(value || "")
      .replace(/\*\*([^*]+)\*\*/g, "$1")
      .replace(/__([^_]+)__/g, "$1")
      .replace(/^#{1,6}\s+/gm, "")
      .replace(/^\s*[-*]\s+/gm, "• ")
      .replace(/`([^`]+)`/g, "$1")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  }

  function renderProposal(proposal) {
    if (!proposal || !proposal.id || el.messages.querySelector('[data-proposal-id="' + proposal.id + '"]')) return;
    var card = document.createElement("article");
    card.className = "mf-nasu-proposal";
    card.setAttribute("data-proposal-id", proposal.id);
    card._proposal = proposal;

    var kicker = document.createElement("p");
    kicker.className = "mf-nasu-proposal-kicker";
    kicker.textContent = "Review before adding";
    var title = document.createElement("h3");
    title.textContent = proposal.display_summary || proposalLabel(proposal.action_type);
    var details = document.createElement("div");
    details.className = "mf-nasu-proposal-details";
    proposalLines(proposal).forEach(function (line) {
      var row = document.createElement("span"); row.textContent = line; details.appendChild(row);
    });
    card.appendChild(kicker); card.appendChild(title); card.appendChild(details);

    if (proposal.conflicts && proposal.conflicts.length) {
      var warning = document.createElement("p");
      warning.className = "mf-nasu-proposal-conflict";
      warning.textContent = "Possible conflict: a similar calendar item already exists. Review carefully before approving.";
      card.appendChild(warning);
    }
    if (proposal.status === "pending") card.appendChild(proposalButtons(card));
    if (proposal.status === "executed") card.appendChild(undoButton(card));
    el.messages.appendChild(card);
    scrollMessages();
  }

  function proposalButtons(card) {
    var actions = document.createElement("div"); actions.className = "mf-nasu-proposal-actions";
    var approve = button("Approve", "is-approve"); var edit = button("Edit", ""); var reject = button("Reject", "");
    approve.addEventListener("click", function () { confirmProposal(card, "approve"); });
    edit.addEventListener("click", function () { toggleProposalEditor(card); });
    reject.addEventListener("click", function () { confirmProposal(card, "reject"); });
    actions.appendChild(approve); actions.appendChild(edit); actions.appendChild(reject);
    return actions;
  }

  function undoButton(card) {
    var actions = document.createElement("div"); actions.className = "mf-nasu-proposal-actions";
    var undo = button("Undo", ""); undo.addEventListener("click", function () { confirmProposal(card, "undo"); });
    actions.appendChild(undo); return actions;
  }

  function toggleProposalEditor(card) {
    var existing = card.querySelector(".mf-nasu-proposal-editor");
    if (existing) { existing.hidden = !existing.hidden; return; }
    var editor = document.createElement("div"); editor.className = "mf-nasu-proposal-editor";
    var proposal = card._proposal; var items = proposal.payload.items || [proposal.payload];
    items.forEach(function (item, index) {
      if (item.text != null) editor.appendChild(editorField("Task" + (items.length > 1 ? " " + (index + 1) : ""), "text", item.text, index));
      if (item.title != null) editor.appendChild(editorField("Title" + (items.length > 1 ? " " + (index + 1) : ""), "title", item.title, index));
      if (item.date != null) editor.appendChild(editorField("Date", "date", item.date, index, "date"));
      if (item.time != null) editor.appendChild(editorField("Time", "time", item.time || "", index, "time"));
      if (item.minutes != null) editor.appendChild(editorField("Minutes", "minutes", item.minutes, index, "number"));
    });
    var actions = card.querySelector(".mf-nasu-proposal-actions");
    card.insertBefore(editor, actions);
  }

  function editorField(labelText, key, value, index, type) {
    var label = document.createElement("label"); var input = document.createElement("input");
    label.appendChild(document.createTextNode(labelText)); input.type = type || "text";
    input.value = value == null ? "" : value; input.setAttribute("data-key", key); input.setAttribute("data-index", index);
    label.appendChild(input); return label;
  }

  function collectEditedPayload(card) {
    var editor = card.querySelector(".mf-nasu-proposal-editor");
    if (!editor || editor.hidden) return null;
    var original = JSON.parse(JSON.stringify(card._proposal.payload));
    var items = original.items || [original];
    Array.prototype.slice.call(editor.querySelectorAll("input")).forEach(function (input) {
      var index = Number(input.getAttribute("data-index") || 0); var key = input.getAttribute("data-key");
      items[index][key] = key === "minutes" ? Number(input.value) : input.value;
      if (key === "time") items[index].all_day = !input.value;
    });
    return original.items ? { items: items } : items[0];
  }

  async function confirmProposal(card, action) {
    if (state.busy || !state.bridge) return;
    state.busy = true;
    setCharacterState("thinking");
    disableCard(card, true);
    try {
      var sessionResult = await state.bridge.db.auth.getSession(); var session = sessionResult.data.session;
      if (!session) throw new Error("login");
      var endpoint = state.bridge.db.supabaseUrl.replace(/\/$/, "") + "/functions/v1/nasu-confirm-action";
      var response = await fetch(endpoint, {
        method: "POST",
        headers: { "Authorization": "Bearer " + session.access_token, "apikey": state.bridge.db.supabaseKey, "Content-Type": "application/json" },
        body: JSON.stringify({ proposal_id: card._proposal.id, action: action, edited_payload: collectEditedPayload(card) })
      });
      var body = await response.json().catch(function () { return {}; });
      if (!response.ok || !body.ok) throw new Error(body.error || "action_failed");
      if (action === "reject") {
        card.remove(); setCharacterState("idle"); el.status.textContent = "Proposal dismissed. Nothing was changed.";
      } else if (action === "undo") {
        card.remove(); setCharacterState("idle"); el.status.textContent = "That Nasú action was undone.";
        refreshStudyLounge();
      } else {
        card._proposal.status = "executed";
        card.querySelector(".mf-nasu-proposal-actions").replaceWith(undoButton(card));
        var editor = card.querySelector(".mf-nasu-proposal-editor"); if (editor) editor.remove();
        if (body.result && body.result.command === "start_pomodoro") {
          state.bridge.startPomodoro(body.result.minutes, body.result.mode);
        }
        setCharacterState("celebrating");
        el.status.textContent = "Confirmed and completed.";
        refreshStudyLounge();
        window.setTimeout(function () { setCharacterState("idle"); }, 2600);
      }
    } catch (error) {
      disableCard(card, false); setCharacterState("error"); el.status.textContent = safeError(error);
      window.setTimeout(function () { setCharacterState("idle"); }, 3200);
    } finally { state.busy = false; }
  }

  function refreshStudyLounge() {
    if (state.bridge.refreshCalendar) state.bridge.refreshCalendar();
    if (state.bridge.refreshChecklist) state.bridge.refreshChecklist();
  }

  async function clearConversation() {
    if (!state.threadId || !state.bridge || !window.confirm("Clear this Nasú conversation? Completed action history will remain for safety.")) return;
    var result = await state.bridge.db.rpc("clear_nasu_history", { p_thread_id: state.threadId });
    if (result.error) { el.status.textContent = "This conversation could not be cleared."; return; }
    state.threadId = null;
    el.messages.textContent = "";
    appendMessage("assistant", "Fresh page. What would you like to work on?");
    el.settings.hidden = true;
    el.status.textContent = "Conversation cleared.";
  }

  function setCharacterState(name) {
    var allowed = ["idle","listening","thinking","talking","celebrating","concerned","confused","sleeping","yawning","grabbed","dragging","error"];
    state.currentState = allowed.indexOf(name) >= 0 ? name : "idle";
    root.setAttribute("data-state", state.currentState);
    el.stateLabel.textContent = stateText(state.currentState);
    renderCharacter(state.currentState);
    if (state.currentState === "idle") scheduleIdleYawn();
  }

  function renderCharacter(name) {
    stopAnimation();
    var assets = window.MemoryFuelNasuAssets || {}; var asset = assets[name] || assets.idle || {};
    state.frameIndex = 0;
    if (asset.type === "frames" && asset.sources && asset.sources.length && !shouldReduceMotion()) {
      asset.sources.forEach(preload);
      drawImage(asset.sources[0]);
      state.frameTimer = window.setInterval(function () {
        if (document.hidden) return;
        state.frameIndex = (state.frameIndex + 1) % asset.sources.length;
        drawImage(asset.sources[state.frameIndex]);
      }, Math.max(80, 1000 / Math.max(1, Math.min(12, asset.fps || 6))));
    } else if (asset.type === "sprite" && asset.source) {
      var sequence = asset.frames && asset.frames.length ? asset.frames : Array.from({ length: Math.max(1, asset.frameCount || 1) }, function (_, index) { return index; });
      preload(asset.source); drawSprite(asset, sequence[0]);
      if (!shouldReduceMotion() && asset.random) {
        scheduleRandomSprite(asset, sequence);
      } else if (!shouldReduceMotion()) {
        state.frameTimer = window.setInterval(function () {
          if (document.hidden) return;
          state.frameIndex = (state.frameIndex + 1) % sequence.length; drawSprite(asset, sequence[state.frameIndex]);
        }, Math.max(240, 1000 / Math.max(.25, Math.min(12, asset.fps || 1))));
      }
    } else if (asset.source) {
      preload(asset.source); drawImage(asset.source);
    } else {
      el.characters.forEach(function (node) { node.style.backgroundImage = ""; node.firstElementChild.hidden = false; });
    }
  }

  function drawImage(source) {
    el.characters.forEach(function (node) {
      node.style.backgroundImage = 'url("' + String(source).replace(/"/g, "") + '")';
      node.style.backgroundSize = "contain"; node.style.backgroundPosition = "center";
      node.firstElementChild.hidden = true;
    });
  }

  function drawSprite(asset, frame) {
    var columns = Math.max(1, asset.columns || asset.frameCount || 1); var rows = Math.max(1, asset.rows || 1);
    el.characters.forEach(function (node) {
      node.style.backgroundImage = 'url("' + String(asset.source).replace(/"/g, "") + '")';
      node.style.backgroundSize = (columns * 100) + "% " + (rows * 100) + "%";
      node.style.backgroundPosition = ((frame % columns) * (100 / Math.max(1, columns - 1))) + "% " + (Math.floor(frame / columns) * (100 / Math.max(1, rows - 1))) + "%";
      node.firstElementChild.hidden = true;
    });
  }

  function scheduleRandomSprite(asset, sequence) {
    var minimum = Math.max(2500, Number(asset.minDelay) || 5000);
    var maximum = Math.max(minimum, Number(asset.maxDelay) || 12000);
    var schedule = function () {
      var delay = minimum + Math.random() * (maximum - minimum);
      state.frameTimer = window.setTimeout(function () {
        if (!document.hidden && sequence.length > 1) {
          var nextIndex = state.frameIndex;
          for (var attempt = 0; attempt < 4 && nextIndex === state.frameIndex; attempt += 1) {
            nextIndex = Math.floor(Math.random() * sequence.length);
          }
          state.frameIndex = nextIndex;
          drawSprite(asset, sequence[state.frameIndex]);
        }
        schedule();
      }, delay);
    };
    schedule();
  }

  function scheduleIdleYawn() {
    if (shouldReduceMotion()) return;
    window.clearTimeout(state.idleEventTimer);
    state.idleEventTimer = window.setTimeout(function () {
      if (state.currentState !== "idle" || state.busy || document.hidden) return scheduleIdleYawn();
      setCharacterState("yawning");
      state.idleEventTimer = window.setTimeout(function () {
        if (state.currentState === "yawning") setCharacterState("idle");
      }, 5900);
    }, 90000);
  }

  function stopAnimation() {
    if (state.frameTimer) {
      window.clearInterval(state.frameTimer);
      window.clearTimeout(state.frameTimer);
    }
    window.clearTimeout(state.idleEventTimer);
    state.frameTimer = null; state.idleEventTimer = null;
  }
  function shouldReduceMotion() { return state.preferences.reduced_motion || window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
  function preload(source) { var image = new Image(); image.src = source; }

  function setupLauncherDrag() {
    var pointer = null;
    el.launcher.addEventListener("pointerdown", function (event) {
      if (event.button != null && event.button !== 0) return;
      var rect = el.launcher.getBoundingClientRect();
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rect.left, top: rect.top, moved: false };
      el.launcher.setPointerCapture(event.pointerId);
      root.classList.add("is-dragging");
      setCharacterState("grabbed");
    });
    el.launcher.addEventListener("pointermove", function (event) {
      if (!pointer || event.pointerId !== pointer.id) return;
      var dx = event.clientX - pointer.x; var dy = event.clientY - pointer.y;
      if (Math.abs(dx) + Math.abs(dy) > 7 && !pointer.moved) {
        pointer.moved = true;
        setCharacterState("dragging");
      }
      if (!pointer.moved) return;
      event.preventDefault();
      placeLauncher(pointer.left + dx, pointer.top + dy);
    });
    var finish = function (event) {
      if (!pointer || event.pointerId !== pointer.id) return;
      root.classList.remove("is-dragging");
      if (pointer.moved) {
        el.launcher.dataset.wasDragged = "yes";
        rememberCurrentPosition();
        void savePreferences();
      }
      setCharacterState("idle");
      pointer = null;
    };
    el.launcher.addEventListener("pointerup", finish);
    el.launcher.addEventListener("pointercancel", finish);
  }

  function placeLauncher(left, top) {
    var viewport = getViewportBounds();
    var width = el.launcher.offsetWidth || 98; var height = el.launcher.offsetHeight || 121;
    var minLeft = viewport.left + 8; var minTop = viewport.top + 8;
    var maxLeft = Math.max(minLeft, viewport.left + viewport.width - width - 8);
    var maxTop = Math.max(minTop, viewport.top + viewport.height - height - 8);
    var safeLeft = Math.min(maxLeft, Math.max(minLeft, left)); var safeTop = Math.min(maxTop, Math.max(minTop, top));
    root.style.left = safeLeft + "px"; root.style.top = safeTop + "px";
    root.style.right = "auto"; root.style.bottom = "auto";
    updatePanelDirection(safeLeft - viewport.left, safeTop - viewport.top, width, height, viewport);
    if (state.open) window.requestAnimationFrame(constrainPanelToViewport);
  }

  function rememberCurrentPosition() {
    var viewport = getViewportBounds();
    var rect = el.launcher.getBoundingClientRect();
    var maxLeft = Math.max(1, viewport.width - rect.width); var maxTop = Math.max(1, viewport.height - rect.height);
    state.preferences.launcher_x = Math.max(0, Math.min(1, (rect.left - viewport.left) / maxLeft));
    state.preferences.launcher_y = Math.max(0, Math.min(1, (rect.top - viewport.top) / maxTop));
    state.preferences.launcher_corner = "bottom_left";
  }

  function applySavedPosition() {
    if (state.preferences.launcher_x == null || state.preferences.launcher_y == null) {
      root.style.left = ""; root.style.top = ""; root.style.right = ""; root.style.bottom = "";
      root.removeAttribute("data-panel-vertical"); root.removeAttribute("data-panel-horizontal");
      return;
    }
    var x = Number(state.preferences.launcher_x); var y = Number(state.preferences.launcher_y);
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
      root.style.left = ""; root.style.top = ""; root.style.right = ""; root.style.bottom = "";
      root.removeAttribute("data-panel-vertical"); root.removeAttribute("data-panel-horizontal");
      return;
    }
    var viewport = getViewportBounds();
    var width = el.launcher.offsetWidth || 98; var height = el.launcher.offsetHeight || 121;
    placeLauncher(viewport.left + x * Math.max(1, viewport.width - width), viewport.top + y * Math.max(1, viewport.height - height));
  }

  function updatePanelDirection(left, top, width, height, viewport) {
    viewport = viewport || getViewportBounds();
    root.setAttribute("data-panel-vertical", top < viewport.height * .48 ? "below" : "above");
    root.setAttribute("data-panel-horizontal", left + width / 2 < viewport.width / 2 ? "right" : "left");
  }

  function getViewportBounds() {
    var visual = window.visualViewport;
    return {
      left: visual ? visual.offsetLeft : 0,
      top: visual ? visual.offsetTop : 0,
      width: visual ? visual.width : document.documentElement.clientWidth,
      height: visual ? visual.height : document.documentElement.clientHeight
    };
  }

  function constrainPanelToViewport() {
    if (!state.open || el.panel.hidden) return;
    el.panel.style.transform = "";
    var viewport = getViewportBounds();
    var rect = el.panel.getBoundingClientRect();
    var inset = 8;
    var leftEdge = viewport.left + inset;
    var rightEdge = viewport.left + viewport.width - inset;
    var topEdge = viewport.top + inset;
    var bottomEdge = viewport.top + viewport.height - inset;
    var shiftX = rect.left < leftEdge ? leftEdge - rect.left : rect.right > rightEdge ? rightEdge - rect.right : 0;
    var shiftY = rect.top < topEdge ? topEdge - rect.top : rect.bottom > bottomEdge ? bottomEdge - rect.bottom : 0;
    if (shiftX || shiftY) el.panel.style.transform = "translate3d(" + shiftX + "px," + shiftY + "px,0)";
  }

  function resetInactivity() {
    window.clearTimeout(state.inactivityTimer);
    state.inactivityTimer = window.setTimeout(function () {
      if (!state.busy && !state.open) setCharacterState("sleeping");
    }, 5 * 60 * 1000);
  }

  function trapFocus(event) {
    var focusable = Array.prototype.slice.call(el.panel.querySelectorAll("button:not([disabled]), textarea:not([disabled]), input:not([disabled])"))
      .filter(function (node) { return !node.closest("[hidden]"); });
    if (!focusable.length) return;
    var first = focusable[0]; var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  async function consumeEvents(stream, handler) {
    var reader = stream.getReader(); var decoder = new TextDecoder(); var buffer = "";
    while (true) {
      var chunk = await reader.read(); if (chunk.done) break;
      buffer += decoder.decode(chunk.value, { stream: true });
      var boundary;
      while ((boundary = buffer.indexOf("\n\n")) >= 0) {
        var block = buffer.slice(0, boundary); buffer = buffer.slice(boundary + 2);
        var event = "message"; var data = "";
        block.split("\n").forEach(function (line) {
          if (line.indexOf("event:") === 0) event = line.slice(6).trim();
          if (line.indexOf("data:") === 0) data += line.slice(5).trim();
        });
        if (data) handler(event, JSON.parse(data));
      }
    }
  }

  function proposalLines(proposal) {
    var payload = proposal.payload || {}; var items = payload.items || [payload]; var lines = [];
    items.slice(0, 6).forEach(function (item) {
      var title = item.text || item.title || (item.minutes ? item.minutes + " minute " + (item.mode || "focus") : "Proposed action");
      var when = item.date || item.due_date || item.time || "";
      lines.push(title + (when ? " • " + when : ""));
    });
    if (items.length > 6) lines.push("+ " + (items.length - 6) + " more items");
    if (proposal.explanation) lines.push(proposal.explanation);
    return lines;
  }
  function proposalLabel(type) { return String(type || "Proposed action").replace(/_/g, " "); }
  function button(text, className) { var node = document.createElement("button"); node.type = "button"; node.textContent = text; if (className) node.className = className; return node; }
  function disableCard(card, disabled) { Array.prototype.slice.call(card.querySelectorAll("button,input")).forEach(function (node) { node.disabled = disabled; }); }
  function scrollMessages() { window.requestAnimationFrame(function () { el.messages.scrollTop = el.messages.scrollHeight; }); }
  function stateText(value) {
    return { idle:"Ready to study", listening:"Listening", thinking:"Thinking it through…", talking:"Talking", celebrating:"Nice work!", concerned:"Worth a closer look", confused:"I need a little more detail", sleeping:"Resting", yawning:"Quick stretch…", grabbed:"Ready to move", dragging:"Moving with you", error:"Something went sideways" }[value] || "Ready to study";
  }
  function safeError(error) {
    var message = error instanceof Error ? error.message : "";
    if (message.indexOf("usage limit") >= 0 || message.indexOf("current Nasú") >= 0) return message;
    if (message === "login") return "Please sign in again before asking Nasú.";
    if (message && message.length < 180 && !/openai|sql|token|key|supabase/i.test(message)) return message;
    return "I hit a snag, but nothing was changed. Please try again.";
  }
  function createUuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (char) {
      return (char ^ window.crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> char / 4).toString(16);
    });
  }
})();
